export type PlanKind = 'EMPLEO' | 'INDIVIDUAL' | 'AUTONOMO';

export enum PlanStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	PENDING_KYC = 'PENDING_KYC',
	SUSPENDED = 'SUSPENDED',
	/** Se está dando de alta: todavía no tiene saldo, se enseña «En proceso». */
	IN_PROGRESS = 'IN_PROGRESS'
}

export interface PlanSummary {
	id: string;
	kind: PlanKind;
	name: string;
	entity: string;
	status: PlanStatus;
	valor?: number;
	/** El logo de su gestora. Sin él, el de ejemplo por `id` y, si no hay, un icono. */
	logoSrc?: string;
}

export interface AdminCompanySummary {
	id: string;
	name: string;
	totalSavedEur: number;
}

export interface AdminAccessSummary {
	companies: AdminCompanySummary[];
}
